<script lang="ts">
  import { onMount } from 'svelte';
  import FooterComponentSquareup from './FooterComponent--squareup.svelte';
  import FooterComponentSqInstallments from './FooterComponent--sqinstallments.svelte';
  import LocaleSelectorModalPartial from '$components/common/partials/ModalPartials/LocaleSelectorModalPartial.svelte';
  import footerLinkTrackingHelper from '$lib/helpers/browser/footer-link-tracking-helper';
  import pwtHelper from '$lib/helpers/browser/pwt-helper';
  import type { FooterComponentProps } from './types';

  export let siteType: FooterComponentProps['siteType'];
  export let address: FooterComponentProps['address'] = undefined;
  export let license: FooterComponentProps['license'] = undefined;
  export let navigationCategory: FooterComponentProps['navigationCategory'] = undefined;
  export let globeIcon: FooterComponentProps['globeIcon'] = undefined;
  export let countryName: FooterComponentProps['countryName'] = undefined;
  export let languageName: FooterComponentProps['languageName'] = undefined;
  export let twitterHandle: FooterComponentProps['twitterHandle'] = undefined;
  export let twitterIcon: FooterComponentProps['twitterIcon'] = undefined;
  export let facebookHandle: FooterComponentProps['facebookHandle'] = undefined;
  export let facebookIcon: FooterComponentProps['facebookIcon'] = undefined;
  export let instagramHandle: FooterComponentProps['instagramHandle'] = undefined;
  export let instagramIcon: FooterComponentProps['instagramIcon'] = undefined;
  export let copyright: FooterComponentProps['copyright'] = undefined;
  export let regulatoryNotice: FooterComponentProps['regulatoryNotice'] = undefined;
  export let legalNotice: FooterComponentProps['legalNotice'] = undefined;
  export let languageDisclaimer: FooterComponentProps['languageDisclaimer'] = undefined;
  export let euCookiePref: FooterComponentProps['euCookiePref'] = undefined;
  export let naCookiePref: FooterComponentProps['naCookiePref'] = undefined;
  export let legalNavigationLinks: FooterComponentProps['legalNavigationLinks'] = undefined;
  export let antiFraudTitle: FooterComponentProps['antiFraudTitle'] = undefined;
  export let antiFraudUrl: FooterComponentProps['antiFraudUrl'] = undefined;
  export let modalPartialConfig: FooterComponentProps['modalPartialConfig'];
  export let countriesAndLangs: FooterComponentProps['countriesAndLangs'] = undefined;

  let accessToDataPrivacyPreferencesRequired = false;
  let defaultConsentRequired = false;

  const openLocaleSelectorModal = () => {
    modalPartialConfig.active = true;
    document.body.style.overflow = 'hidden';
  };

  onMount(async () => {
    pwtHelper.addDependent(footerLinkTrackingHelper);
    pwtHelper.subscribeDependents();
    window.Sq.Tracking.subscribe('sq:oneTrustInitialized', (ev: CustomEvent<Sq.Tracking.TrackingPermissions>) => {
      accessToDataPrivacyPreferencesRequired = Boolean(ev.detail.accessToDataPrivacyPreferencesRequired);
      defaultConsentRequired = Boolean(ev.detail.defaultConsentRequired);
    });
  });
</script>

<footer class="FooterComponent" id="footer">
  <div class="content">
    {#if siteType === 'sqcapitallicenses' || siteType === 'squareinstallments'}
      <FooterComponentSqInstallments
        {navigationCategory}
        {globeIcon}
        {countryName}
        {languageName}
        {copyright}
        {address}
        {license}
        {legalNavigationLinks}
        {openLocaleSelectorModal}
        {languageDisclaimer}
      />
    {:else}
      <FooterComponentSquareup
        {navigationCategory}
        {globeIcon}
        {countryName}
        {languageName}
        {twitterHandle}
        {twitterIcon}
        {facebookHandle}
        {facebookIcon}
        {instagramHandle}
        {instagramIcon}
        {copyright}
        {regulatoryNotice}
        {legalNotice}
        {euCookiePref}
        {naCookiePref}
        {legalNavigationLinks}
        {antiFraudTitle}
        {antiFraudUrl}
        {openLocaleSelectorModal}
        {defaultConsentRequired}
        {accessToDataPrivacyPreferencesRequired}
        {languageDisclaimer}
      />
    {/if}

    {#if modalPartialConfig && countriesAndLangs}
      <LocaleSelectorModalPartial {modalPartialConfig} {countriesAndLangs} />
    {/if}
  </div>
</footer>

<style lang="scss">
  @layer standard-components {
    .FooterComponent {
      margin-top: auto;
      position: relative;
      background-color: var(--color-gray-99);
      color: var(--color-gray-55);
      line-height: var(--line-height-21);
      font-size: var(--font-size-14);
    }

    .content {
      padding: var(--space-60) 0;
    }
  }
</style>
